<div class="mainpanel" [hidden]="!ViewReady">
    <h1>Reports <span *ngIf="AwardInfo"> - {{AwardInfo.BannerName}}</span></h1>
    <p>Choose from the following available reports:</p>

    <div *ngFor="let report of AvailableReports; let even = even">
        <div [class.coloredRow]="even" fxLayout="row" fxLayoutAlign="space-between center">
            <div class="margin">
                <mat-icon>description</mat-icon>
            </div>
            <div fxFlex>
                <h2>{{report.Title}}</h2>
                <p>{{report.Description}}</p>
            </div>
            <div class="margin">
                <button mat-raised-button color="primary" (click)="RunReport(report)">Run Report</button>
            </div>
        </div>
    </div>
</div>